import prisma from '@/prisma/client'

type RegionWithLocations = {
  id: number
  name: string
  locations: {
    id: number
    name: string
  }[]
}

type Props = {
  regions: RegionWithLocations[]
  location?: string
  region?: string
}

export function findSelectedLocation(props: Props) {
  const { regions, location, region } = props
  const locationId = Number(location)
  const regionId = Number(region)

  if (location) {
    const flatLocations = regions.flatMap((region) => region.locations)
    return flatLocations.find((location) => location.id === locationId)
  }

  if (region) {
    return regions.find((region) => region.id === regionId)
  }

  return null
}

export async function getDBRegionsWithLocations() {
  const regions = await prisma.region.withCache({}).findMany({
    include: {
      locations: true,
    },
  })

  return regions
}
